/*=========================================================================================
  File Name: moduleTodoListctions.js
  Description: TodoListModule Actions
==========================================================================================*/

import formGql from "@/http/requests/agile/form_gql";
import deviceGql from "@/http/requests/cbs/device_gql";
import todoListGql from "@/http/requests/cbs/todo_list_gql";
import userOptionGQL from "@/http/requests/agile/user_option_gql";
import employeeInsideGql from "@/http/requests/inside/employee_gql";
import reminderGql from "@/http/requests/cbs/reminder_gql";

export default {
	reportTodoList({ commit }, payload) {
		return new Promise((resolve, reject) => {
			todoListGql
				.fetchTodoList(payload)
				.then(response => {
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	fetchTodoListManagement({ commit }, payload) {
		return new Promise((resolve, reject) => {
			todoListGql
				.fetchTodoList(payload)
				.then(response => {
					commit("SET_TODO_LIST", response.todoList);
					commit("SET_TOTAL_TODO_LIST", response.totalTodoList);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	addTodoItem({ state, commit }, todoItem) {
		return new Promise((resolve, reject) => {
			todoListGql
				.addTodoItem(todoItem)
				.then(response => {
					commit("SET_TOTAL_TODO_LIST", state.totalTodoList + 1);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	updateTodoItem({ commit }, todoItem) {
		return new Promise((resolve, reject) => {
			todoListGql
				.updateTodoItem(todoItem)
				.then(response => {
					commit("UPDATE_TODO_ITEM", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	completeTodoItem({ commit }, payload) {
		return new Promise((resolve, reject) => {
			todoListGql
				.completeTodoItem(payload)
				.then(response => {
					commit("UPDATE_TODO_ITEM", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	ratingTodoItem({ commit }, payload) {
		return new Promise((resolve, reject) => {
			todoListGql
				.ratingTodoItem(payload)
				.then(response => {
					commit("UPDATE_TODO_ITEM", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	fetchDevices({ commit }, payload) {
		return new Promise((resolve, reject) => {
			deviceGql
				.fetchDevices(payload)
				.then(response => {
					commit("SET_DEVICES", response.devices);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	fetchEmployees({ commit }, payload) {
		return new Promise((resolve, reject) => {
			employeeInsideGql
				.fetchEmployees(payload)
				.then(response => {
					commit("SET_EMPLOYEES", response.employees);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	getTodoItem({ commit }, id) {
		return new Promise((resolve, reject) => {
			todoListGql
				.getTodoItem(id)
				.then(response => {
					commit("UPDATE_TODO_ITEM", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	addCheckListItem(store, payload) {
		return new Promise((resolve, reject) => {
			todoListGql
				.addCheckListItem(payload)
				.then(response => {
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	updateCheckListItem(store, payload) {
		return new Promise((resolve, reject) => {
			todoListGql
				.updateCheckListItem(payload)
				.then(response => {
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	deleteCheckListItem(store, payload) {
		return new Promise((resolve, reject) => {
			todoListGql
				.deleteCheckListItem(payload)
				.then(response => {
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	checkDoneCheckListItem(store, payload) {
		return new Promise((resolve, reject) => {
			todoListGql
				.checkDoneCheckListItem(payload)
				.then(response => {
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	getTodoLogs(store, payload) {
		return new Promise((resolve, reject) => {
			todoListGql
				.fetchTodoLogs(payload)
				.then(response => {
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	cancelTodoItem({ commit }, payload) {
		return new Promise((resolve, reject) => {
			todoListGql
				.cancelTodoItem(payload)
				.then(response => {
					commit("REMOVE_TODO_ITEM", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	rejectTodoItem({ commit }, payload) {
		return new Promise((resolve, reject) => {
			todoListGql
				.rejectTodoItem(payload)
				.then(response => {
					commit("REMOVE_TODO_ITEM", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	submitReportFormTodoItem({ commit }, payload) {
		return new Promise((resolve, reject) => {
			formGql
				.submitReportForm(payload)
				.then(response => {
					commit("SUBMIT_REPORT_FORM_TODO_ITEM", { todoItemId: payload.formable_id, data: response });
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	setMarkedColor({ commit }, payload) {
		return new Promise((resolve, reject) => {
			userOptionGQL
				.updateUserOption(payload)
				.then(response => {
					commit("UPDATE_TODO_MARKED_COLOR", { id: payload.optionable_id, color: response.color });
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	updateReminder(store, payload) {
		return new Promise((resolve, reject) => {
			reminderGql
				.updateReminder(payload)
				.then(response => {
					// commit("UPDATE_TODO_ITEM", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	deleteReminder(store, payload) {
		return new Promise((resolve, reject) => {
			reminderGql
				.deleteReminder(payload)
				.then(response => {
					// commit("UPDATE_TODO_ITEM", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	setStatusTodo({ commit }, payload) {
		return new Promise((resolve, reject) => {
			todoListGql
				.setStatusTodo(payload)
				.then(response => {
					commit("UPDATE_TODO_ITEM", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	toggleScheduleTodolist({ commit }, payload) {
		return new Promise((resolve, reject) => {
			todoListGql
				.toggleScheduleTodolist(payload)
				.then(response => {
					commit("UPDATE_TODO_ITEM", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	getTodoChildByParent({ commit }, payload) {
		return new Promise((resolve, reject) => {
			todoListGql
				.fetchTodoList(payload)
				.then(response => {
					commit("UPDATE_TODO_LIST_CHILD", response.todoList);
					// commit("UPDATE_TODO_LIST", response.todoList);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	removeOldChildItems({ commit }, payload) {
		commit("REMOVE_OLD_TODO_LIST", payload);
	},
	updateTodoItemWatcher({ commit }, payload) {
		return new Promise((resolve, reject) => {
			todoListGql
				.updateTodoItemWatcher(payload)
				.then(response => {
					commit("UPDATE_TODO_ITEM", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	updateMultipleTodoItem(store, payload) {
		return new Promise((resolve, reject) => {
			todoListGql
				.updateMultipleTodoItem(payload)
				.then(response => {
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	getTodolistCount({ commit }, payload) {
		return new Promise((resolve, reject) => {
			todoListGql
				.getTodolistCount(payload)
				.then(response => {
					commit("UPDATE_TODOLIST_COUNT", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	createCloneTodoItem({ state, commit }, payload) {
		return new Promise((resolve, reject) => {
			todoListGql
				.cloneTodolist(payload)
				.then(response => {
					const _total = state.totalTodoList + 1;
					commit("SET_TOTAL_TODO_LIST", _total);
					commit("ADD_TODO_LIST", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	updateTodoItemAttachs({ commit }, payload) {
		return new Promise((resolve, reject) => {
			todoListGql
				.updateTodoItemAttachs(payload)
				.then(response => {
					commit("UPDATE_TODO_ITEM", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	updateTodoItemLocal({ commit }, todo) {
		commit("UPDATE_TODO_ITEM", todo);
	},
	resetDataTodoListChild({ commit }) {
		commit("SET_TODO_LIST_CHILD", []);
	}
};
